import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../Shared/GlobalContext/ThemeContext';
import { getMediaTypeDisplay } from '../../utils/getMediaTypeDisplay';

/**
 * Displays a preview of the message being replied to with a cancel button.
 * Shows above the message footer when a reply is active.
 */
const MessageInputReplyPreview = ({ replyTo, onCancel }) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();

    if (!replyTo) return null;

    // Determine what to display: content or media type
    const getDisplayText = () => {
        if (replyTo.content) {
            return replyTo.content;
        }

        // If no content but has media, show media type with icon
        if (replyTo.media && replyTo.media.length > 0) {
            const firstMedia = replyTo.media[0];
            const { icon, translationKey } = getMediaTypeDisplay(firstMedia.media_type);
            return `${icon} ${t(translationKey)}`;
        }

        // Fallback for messages with neither content nor media
        return '';
    };

    const styles = {
        container: {
            padding: '8px 16px',
            borderTop: `1px dashed ${isDarkMode ? '#434343' : '#eff3f4'}`,
            background: isDarkMode ? '#1f1f1f' : '#fafafa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 8
        },
        content: {
            borderInlineStart: `2px solid ${isDarkMode ? '#FFD700' : '#1890ff'}`,
            paddingInlineStart: 8,
            overflow: 'hidden'
        },
        label: {
            fontSize: 11,
            opacity: 0.75
        },
        text: {
            fontSize: 12,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflow: 'hidden'
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={styles.label}>{t('replying_to')}</div>
                <div style={styles.text}>
                    {getDisplayText()}
                </div>
            </div>
            <Button size="small" onClick={onCancel}>
                {t('cancel')}
            </Button>
        </div>
    );
};

export default MessageInputReplyPreview;

